// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"c964e242","52":"a68967ee","228":"60a1e29d","433":"94030528","455":"1ca17978","977":"240addac"}[chunkId] + ".chunk.js";
};